export default {
    mq: {
        key: 'mq',
        anchor: 'section-mq',
        facets: ['mq'],
        sectionTitle: 'Media queries',
    },
    grid: {
        key: 'grid',
        anchor: 'section-grid',
        facets: ['grid'],
        sectionTitle: 'Grid',
    },
    colors: {
        key: 'colors',
        anchor: 'section-colors',
        facets: ['colors'],
        sectionTitle: 'Colors',
    },
    shadows: {
        key: 'shadows',
        anchor: 'section-shadows',
        facets: ['shadows'],
        sectionTitle: 'Shadows',
    },
    typo: {
        key: 'typo',
        anchor: 'section-typo',
        facets: ['typo'],
        sectionTitle: 'Typography',
    },
    icons: {
        key: 'icons',
        anchor: 'section-icons',
        facets: ['icons'],
        sectionTitle: 'Icons',
    },
    buttons: {
        key: 'buttons',
        anchor: 'section-buttons',
        facets: ['buttons'],
        sectionTitle: 'Buttons',
    },
    forms: {
        key: 'forms',
        anchor: 'section-forms',
        facets: ['forms'],
        sectionTitle: 'Forms',
    },
};
